import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import {ISSUE_ATTRIBUTES_DATA_TYPES} from '../../constants/issue-attributes';
import {getIssueCustomAttributeInputValidationMessage} from '../../utils/validation-helpers';
import IssueFieldInlineEdit from './IssueFieldInlineEdit';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import TextFieldInlineEdit from './TextFieldInlineEdit';
import {issueAttributesType} from '../../constants/proptype-validation/index';
import {updateValueInCustomAttributesArray} from '../../utils/issueAttributes-helpers';
import isNullOrUndefined from '@adsk/bim360-matrix-react-helpers/es/isNullOrUndefined';

export default class IssueCustomAttributeTextInlineEdit extends React.PureComponent {
  constructor(props) {
    super(props);

    this.getValue = this.getValue.bind(this);
    this.getIssueAttributes = this.getIssueAttributes.bind(this);
  }

  parseValue(value) {
    return isNullOrUndefined(value) ? '' : value.toString();
  }

  parseNumericValue(value) {
    const parsedValue = parseFloat(value);
    return isNaN(parsedValue) ? value : parsedValue;
  }

  getValue(issue) {
    const {customAttribute} = this.props;
    const issueCustomAttribute = issue[ISSUE_ATTRIBUTE_NAMES.CUSTOM_ATTRIBUTES].find(
      issueAttribute => issueAttribute.attributeDefinitionId === customAttribute.id
    );
    return issueCustomAttribute ? this.parseValue(issueCustomAttribute.value) : null;
  }

  getValidator() {
    return getIssueCustomAttributeInputValidationMessage.bind(this, this.props.customAttribute.dataType);
  }

  getClassName() {
    const className = 'IssueCustomAttributeTextInlineEdit ';
    switch (this.props.customAttribute.dataType) {
      default:
      case ISSUE_ATTRIBUTES_DATA_TYPES.TEXT:
        return `${className}IssueCustomAttributeTextInlineEdit__text`;
      case ISSUE_ATTRIBUTES_DATA_TYPES.PARAGRAPH:
        return `${className}IssueCustomAttributeTextInlineEdit__multi-line-text`;
      case ISSUE_ATTRIBUTES_DATA_TYPES.NUMERIC:
        return `${className}IssueCustomAttributeTextInlineEdit__numeric-text`;
    }
  }

  getIssueAttributes(value) {
    const {customAttribute, issue} = this.props;
    if (customAttribute.dataType === ISSUE_ATTRIBUTES_DATA_TYPES.NUMERIC) {
      value = this.parseNumericValue(value);
    }
    const customAttributes = updateValueInCustomAttributesArray(
      issue[ISSUE_ATTRIBUTE_NAMES.CUSTOM_ATTRIBUTES],
      customAttribute.id,
      value
    );
    return {
      [ISSUE_ATTRIBUTE_NAMES.CUSTOM_ATTRIBUTES]: customAttributes
    };
  }

  render() {
    const {disabled, customAttribute, issue, isRequired} = this.props;
    const {id, title, dataType} = customAttribute;
    const multiLine = dataType === ISSUE_ATTRIBUTES_DATA_TYPES.PARAGRAPH;

    const className = this.getClassName();

    return (
      <TextFieldInlineEdit
        issue={issue}
        attributeName={ISSUE_ATTRIBUTE_NAMES.CUSTOM_ATTRIBUTES}
        key={id}
        label={title}
        linkify
        disabled={disabled}
        isRequired={isRequired}
        multiline={multiLine}
        placeholder={i18n.t('unspecifiedValue')}
        className={className}
        data-testid={className}
        inputValidator={this.getValidator()}
        styleType={IssueFieldInlineEdit.StyleTypes.SMALL}
        getFieldValue={this.getValue}
        getIssueAttributes={this.getIssueAttributes}
      />
    );
  }
}

IssueCustomAttributeTextInlineEdit.propTypes = {
  issue: issueAttributesType,
  customAttribute: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  isRequired: PropTypes.bool
};
IssueCustomAttributeTextInlineEdit.displayName = 'IssueCustomAttributeTextInlineEdit';
